import React from 'react';
import { Paper, BottomNavigation, BottomNavigationAction, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { sectionIcons } from '../../assets/icons';

// Icono de sección monocromo: se tiñe con el color del ítem (currentColor) mediante mask,
// adoptando el gris en inactivo y el índigo cuando está seleccionado.
const NavImgIcon = ({ src }) => (
    <Box
        component="span"
        sx={{
            width: 30,
            height: 30,
            display: 'block',
            bgcolor: 'currentColor',
            transition: 'background-color 0.2s ease',
            WebkitMaskImage: `url(${src})`,
            maskImage: `url(${src})`,
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            maskPosition: 'center',
            WebkitMaskSize: 'contain',
            maskSize: 'contain',
        }}
    />
);

const MobileNav = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Determine value based on path
    const getValue = () => {
        const path = location.pathname;
        if (path.startsWith('/dashboard')) return 0;
        if (path.startsWith('/menu-semanal')) return 1;
        if (path.startsWith('/recetas')) return 2;
        if (path.startsWith('/listas')) return 3;
        if (path.startsWith('/perfil')) return 4;
        return 0;
    };

    const value = getValue();

    return (
        <Paper
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1300,
                borderRadius: '24px 24px 0 0',
                boxShadow: '0 -4px 20px rgba(0,0,0,0.05)',
                overflow: 'hidden'
            }}
            elevation={3}
        >
            <BottomNavigation
                showLabels // Mostrar siempre el título de cada apartado, esté o no seleccionado
                value={value}
                onChange={(event, newValue) => {
                    switch (newValue) {
                        case 0: navigate('/dashboard'); break;
                        case 1: navigate('/menu-semanal'); break;
                        case 2: navigate('/recetas'); break;
                        case 3: navigate('/listas'); break;
                        case 4: navigate('/perfil'); break;
                        default: break;
                    }
                }}
                sx={{
                    height: 74,
                    '& .MuiBottomNavigationAction-root': {
                        color: '#94a3b8',
                        minWidth: 0,
                        px: 0.5,
                        gap: '2px',
                        '&.Mui-selected': {
                            color: '#4f46e5'
                        }
                    },
                    '& .MuiBottomNavigationAction-label': {
                        fontSize: '0.62rem',
                        fontWeight: 600,
                        lineHeight: 1.1,
                        textAlign: 'center',
                        opacity: 1,
                        // Evitar el salto de tamaño que MUI aplica al label seleccionado
                        '&.Mui-selected': {
                            fontSize: '0.62rem',
                            fontWeight: 700
                        }
                    }
                }}
            >
                <BottomNavigationAction icon={<NavImgIcon src={sectionIcons.dashboard} />} label="Inicio" />
                <BottomNavigationAction icon={<NavImgIcon src={sectionIcons.planSemanal} />} label="Plan semanal" />
                <BottomNavigationAction icon={<NavImgIcon src={sectionIcons.recetas} />} label="Recetas" />
                <BottomNavigationAction icon={<NavImgIcon src={sectionIcons.lists} />} label="Listas" />
                <BottomNavigationAction icon={<NavImgIcon src={sectionIcons.user} />} label="Perfil" />
            </BottomNavigation>
        </Paper>
    );
};

export default MobileNav;
